import { IAdminApiConfig } from "../../configs/IAdminApiConfig";
import { MyCAIApiService } from "../MyCAIApiService";

export class AdminApiService extends MyCAIApiService {
    public Styles: StylesService;

	constructor(config: IAdminApiConfig) {
		super(config);

        this.Styles = new StylesService(this);		
	}
}

interface ColorsDict {
    [key: string]: string | null; // Allow null values to match your API
}


const DefaultColors: string[] = [
    "action-color",
    "action-color-hover",
    "brand",
    "brand-complement",
    "action-color-complement",
    "disabled-button-bg",
    "disabled-button-bg-hover",
    "disabled-button-text",
    "body-text",
    "body-text-muted",
    "accent",
    "accent-complement",
    "heading-text",
    "focus",
    "destructive",
    "destructive-hover",
    "body-bg",
    "action-color-faded",
    "action-color-dark",
    "surface-low-contrast-ai",
    "surface-low-contrast-ai-complement",
    "app-title",
    "app-title-suffix",
    "app-subtitle",
    "line-low-contrast",
    "nav-bg",
    "body-to-transparent-stop-0",
    "body-to-transparent-stop-74",
    "body-to-transparent-stop-85",
    "body-to-transparent-stop-100",
    "success",
    "success-complement",
    "error",
    "error-complement",
    "error-hover",
    "neutral",
    "neutral-complement",
    "informational",
    "informational-complement",
    "warning",
    "warning-faded",
    "surface-high-contrast",
    "surface-high-contrast-complement",
    "surface-high-contrast-success",
    "surface-high-contrast-error",
    "surface-high-contrast-glass",
    "surface-high-contrast-warning",
    "surface-low-contrast-alt"
];


class StylesService {
    private apiService: AdminApiService;

    constructor(apiService: AdminApiService) {
		this.apiService = apiService;
	}

    // Gets multiple colors by their keys using batch endpoint
    public async getColors(keys: string[] = DefaultColors): Promise<ColorsDict> {
        const endpoint = `/framework/${
            this.apiService.getConfig().apiVersion
        }/AppConfig/batch`;
        return this.apiService.sendRequest({
            method: "post",
            endpoint,
            data: keys
        });
    }

    // Updates multiple colors using batch endpoint
    public async setColors(colors: ColorsDict): Promise<any> {
        const endpoint = `/framework/${
            this.apiService.getConfig().apiVersion
        }/AppConfig/batch`;
        return this.apiService.sendRequest({
            method: "put",
            endpoint,
            data: {
            updates: colors
            }
        });
    }
	
}
